import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { useHyphenateRu } from '@/hooks/useHyphenateRu';
import type { Project } from '@/api/client';
import { highlightPlainText } from '@/utils/highlightSearchTerms';

interface ThemeCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

export const ThemeCell = memo(function ThemeCell({ project, searchHighlightWords }: ThemeCellProps) {
  const hyphenated = useHyphenateRu(project.theme ?? null);

  return (
    <EditableCell project={project} fieldKey="theme">
      {project.theme ? (
        <div className="projects-table__theme-cell" lang="ru">
          {searchHighlightWords?.length ? highlightPlainText(hyphenated, searchHighlightWords) : hyphenated}
        </div>
      ) : (
        <span className="projects-table__empty-value">N/A</span>
      )}
    </EditableCell>
  );
});
